import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/images/merchant-logo.png'


const _hoisted_1 = { class: "order-info" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "merchant-name" }
const _hoisted_4 = { class: "table-number-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "table-number-heading" }, "Table", -1)
const _hoisted_6 = { class: "table-number" }
const _hoisted_7 = {
  key: 0,
  class: "table-amount-wrapper"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "table-amount-heading" }, "Total", -1)
const _hoisted_9 = { class: "table-amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_progress_bar = _resolveComponent("progress-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.order.site.name), 1),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.order.table), 1)
    ]),
    (!_ctx.showProgressBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("p", _hoisted_9, "$" + _toDisplayString((_ctx.order.remaining.amount/100).toFixed(2)), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showProgressBar)
      ? (_openBlock(), _createBlock(_component_progress_bar, {
          key: 1,
          order: _ctx.order
        }, null, 8, ["order"]))
      : _createCommentVNode("", true)
  ]))
}